import { Component, OnInit, ViewChild } from '@angular/core';
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Option-origin-code-Columns.json';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { GridService } from 'app/Shared/Services/grid.service';
import { HttpErrorResponse } from '@angular/common/http';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { Table, TableModule } from 'primeng/table';
import { OptionOriginCode } from './option-origin-code.model';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService } from 'primeng/api';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { CommonModule, LowerCasePipe, NgClass} from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ButtonModule } from 'primeng/button';
import { OocCmtaDetailsComponent } from './ooc-cmta-details/ooc-cmta-details.component';
import { OptionOriginCodeGraphComponent } from './option-origin-code-graph/option-origin-code-graph.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-option-origin-code',
    imports: [FilterPanelComponent, ExportToCSVSComponent, CommonModule,MatProgressSpinner, TableModule, NgClass, ButtonModule,
        OocCmtaDetailsComponent, OptionOriginCodeGraphComponent, MatTooltipModule, LowerCasePipe, ToastModule],
    templateUrl: './option-origin-code.component.html',
    styleUrls: ['./option-origin-code.component.scss']
})
export class OptionOriginCodeComponent implements OnInit {
  @ViewChild(('dt')) dt!: Table;
  GridColumns = GridColumnsJSON;
  dataset: OptionOriginCode[] = [];
  selectedRow: OptionOriginCode = new OptionOriginCode();
  isLoadingResults: boolean = true;
  tbldatamsg: string = "L o a d i n g . . . . .";
  totalRecords!: number;
  Limit: any = { 'Start': '', 'End': '' };
  previousLimit: any = { 'Start': '', 'End': '' };
  defaultFilterArray: any = [];
  startLimit: any = 0;
  endLimit!: number;
  rowcount!: number;
  columnJson: any = [];
  cols: any = []
  priviousStartLimit: any;
  pageNumber: any = 1;
  isShowGraph: boolean = false;
  LastExecutionDate!: any[];
  tblColBgColor: string = ''
  isShowCMTADetails: boolean = false;
  constructor(private gridService: GridService,
    public constantService: ConstantService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    private messageService: MessageService,
    private emitterService: EmitterService,
    private userService: UserService) {
  }

  ngOnInit() {
    this.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.endLimit = this.rowcount;
    this.Limit = { 'Start': '0', 'End': this.endLimit };
    this.totalRecords = this.rowcount;
    this.defaultFilter();
    this.getColumns();
    this.getData();
  }
  getColumns() {
    let column: any = this.GridColumns;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.columnJson = this.gridService.getGridColumns(column);
      this.cols = this.gridService.getGridColumns(column);
    }
  }
  changePage(event: any) {
    this.startLimit = event.first;
    this.endLimit = this.startLimit + this.rowcount;
    this.rowcount = event.rows;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;
    this.getData();
  }

  getData() {
    this.previousLimit = this.Limit;
    this.dataset = [];
    this.selectedRow = new OptionOriginCode();
    this.isLoadingResults = true;
    this.isShowGraph =  false;
    this.tbldatamsg = "L o a d i n g . . . . .";
    const filterData = JSON.parse(JSON.stringify(this.defaultFilterArray));
    filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));

    let payload = {
      data: filterData,
      mpid: this.userService.getActiveMPID(),
      exceptionType: this.defaultFilterArray[4].values,
      startLimit: this.Limit.Start.toString(),
      endLimit: this.Limit.End.toString(),
      pageName: "Option Origin Code"
    }
    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.OptionOriginCode
      ),
      payload
    )
      .subscribe({
        next: (Element:any) => {
        this.isLoadingResults = false;
        let dataset: any = Element;
        this.dataset = dataset.response.data;
        this.totalRecords = dataset.response.totalCount ?? 0;
        this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        if (this.dataset.length == 0) {
          this.tbldatamsg = "No data found";
        }
      }, error: (err: HttpErrorResponse) => {
        this.dataset = [];
        this.totalRecords = 0;
        this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        this.isLoadingResults = false;
      }});
  }
  defaultFilter() {
    let date = new Date();
      this.LastExecutionDate = [];
      this.LastExecutionDate.push(date); // FromDate
      this.LastExecutionDate.push(date); // Todate
    this.defaultFilterArray = [
      {
        "isdefault": "true",
        "label": "Date",
        "columnname": "reportDate",
        "filterby": "IS",
        "values": this.LastExecutionDate,
        "time": "",
        'datatype': 'DateRange',
        "disabled": "true",
        "dropdown": "",
        "dropdownvalue": ""
      },
      {
        "isdefault": "true",
        "label": "Customer Id",
        "columnname": "customerId",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": "true",
        "dropdown": "",
        "dropdownvalue": ""
      },
      {
        "isdefault": "true",
        "label": "Customer Name",
        "columnname": "customerName",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": "true",
        "dropdown": "",
        "dropdownvalue": ""
      },
      {
        "isdefault": "true",
        "label": "Acronym",
        "columnname": "customerAcronym",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": "true",
        "dropdown": "",
        "dropdownvalue": ""
      },
      {
        "isdefault": "true",
        'label': 'Exception Type',
        'columnname': 'ExceptionType',
        'filterby': 'IS',
        'values': '',
        'time': '',
        'datatype': 'skip',
        'disabled': 'true',
        'dropdown': 'YES',
        'dropdowntype': 'singleSelect',
        'dropdownvalue': [
          {
            "label": "All",
            "value": "All",
            "description": 'All Records'
          },
          {
            "label": "Warning"
            , "value": "Warning",
            "description": 'records where clearingAccount Code != P and OrderCount >= 350'
          },
          {
            "label": "Exceptions",
            "value": "Exceptions",
            "description": 'records where clearingAccount Code != P and OrderCount >= 390'
          }]
      },

    ]
  }

  filterApplyFilterEvent(event: any) {
    this.defaultFilterArray = [];
    this.defaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.getData();
  }
  openDialog(rowData: OptionOriginCode) {
    this.selectedRow = rowData;
    this.isShowCMTADetails = true;
  }
  onRowSelect(rowData: any) {
    this.selectedRow = rowData;
    this.isShowGraph = true;
  }
  getBgColor(header: any,value: any) {
    if (header != 'Account Code') {
      if (value >= 350 && value <= 389) {
        this.tblColBgColor = 'td_bg_color_yellow';
      } else if (value >= 390) {
        this.tblColBgColor = 'td_bg_color_red';
      } else {
        this.tblColBgColor = '';
      }
    } else if (header === 'Account Code' && value === '#') {
      this.tblColBgColor = 'td_bg_color_yellow';
    }
    else {
      this.tblColBgColor = '';
    }
    return this.tblColBgColor;
  }
  exportToCSV(event: any) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    let exportLimt: any;
    if (event.isExportMaxRows) {
      exportLimt = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      exportLimt = this.previousLimit;
    }
    let payload = {
      data: this.defaultFilterArray,
      mpid: this.userService.getActiveMPID(),
      exceptionType: this.defaultFilterArray[4].values,
      startLimit: exportLimt.Start.toString(),
      endLimit: exportLimt.End.toString(),
      pageName: "Option Origin Code"
    }
    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.OptionOriginCode
      ),
      payload
    ).subscribe({
      next: (Element:any) => {
        let dataset: any = Element;
        dataset = dataset.response.data;
      if (dataset.length > 0) {
        const options: any = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'RSMS_Survillance_OOC_' + this.userService.getyyyyMMddDateFormate(new Date()),
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
          filename: this.userService.getActiveMPID() +'_RSMS_Survillance_OOC_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
        };
        const csvData = this.constantService.getExportData(dataset, event.gridColumn);
        const csv = generateCsv(options)(csvData);
        const blob = asBlob(options)(csv);
        saveAs(blob,options.filename);

        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'File Download Successfully | ' + (dataset.length > 0 ? dataset.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.defaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'No data found',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.defaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
      this.emitterService.exportToCSVData.emit(true);

    }, error: (err: HttpErrorResponse) => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
      this.userService.logUserActivity('Export CSV', null, {
        'Text1': 'Error while Exporting',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.defaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }});
  }
}
